import React, {useContext, useEffect} from 'react';
import {
  useHistory , useRouteMatch, Switch, useLocation,
  Route,
} from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {Heading} from "../atoms/Heading/Heading";
import {store} from "../store";
import {hasScope} from "../helpers/scopes";
import {KitesData} from "../Kites/KitesData";
import Staff from 'Main/Staff';
import QuestionsList from 'Questions/QuestionsList';
import {EventTypes} from './EventTypes';

export const Settings= () => {
  const history = useHistory();
  let location = useLocation();
  let match = useRouteMatch();
  const {state} = useContext(store);
  const canViewStaff = hasScope(state.user, 'users:read');
  let customer = window.location.pathname.split('/')[1];
  const [value, setValue] = React.useState(location.pathname);

  useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  const handleChange = (event, newValue) => {
    history.push(newValue);
  };

  return (
    <div>
      <Heading message={'Settings'} />
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {canViewStaff && <Tab label="Team" value={`/${customer}/settings`}/>}
        <Tab label="Kite Templates" value={`${canViewStaff ? `/${customer}/settings/kite` : `/${customer}/settings`}`}/>
        <Tab label="Venue Questions" value={`/${customer}/settings/questions`}/>
        <Tab label="Config" value={`/${customer}/settings/config`}/>
      </Tabs>
      <div style={{margin: '32px 4px 0'}}>
        <Switch >
          <Route path={`${match.path}/kite`}>
            <KitesData site={state.site} templates={true} />
          </Route>
          <Route path={`${match.path}/questions`}>
            {state.site?._id && <QuestionsList venueID={state.site?._id}/>}
          </Route>
          <Route path={`${match.path}/config`}>
            <EventTypes />
          </Route>
          <Route path={match.path}>
            {canViewStaff ? <Staff/> : <KitesData site={state.site} templates={true} />}
          </Route>
        </Switch>
      </div>
    </div>
  );
}
